module.exports = __webpack_public_path__ + "/login_ui/img/pg-ed6a66a48b51296b2b44242e387136ca.svg";